import { render, staticRenderFns } from "./useOrder.vue?vue&type=template&id=501c50ba"
import script from "./useOrder.vue?vue&type=script&lang=js"
export * from "./useOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports